module.exports = __webpack_public_path__ + "static/media/sub-weapon.19c3e66a.png";